<template>
   <div ref="dropdown" class="pull-right dropdown">
      <!-- TODO: cannot display tooltip with dropdown, because
      data-toggle="popover" conflicts with data-toggle="dropdown" -->
      <!-- <span
         v-popover
         ref="tooltip"
         class="star-box"
         data-container="body"
         data-toggle="popover"
         data-trigger="hover"
         data-placement="bottom"
         data-content="Select a sort option"

         v-popover
         ref="tooltip"
         data-container="body"

         data-trigger="hover"
         data-placement="bottom"
         data-content="Select a sort option - new"

      > -->
      <button
         id="dropdownMenuButton"
         :disabled="disabled"
         class="btn btn-light dropdown-toggle"
         type="button"
         v-popover
         ref="tooltip"
         data-container="body"
         data-trigger="hover"
         data-placement="top"
         data-content="Select a sort option"
         data-toggle="dropdown"
         aria-haspopup="true"
         aria-expanded="false"
      >
         Sort by
      </button>
      <!-- </span> -->
      <div class="dropdown-menu sort-menu" aria-labelledby="dropdownMenuButton">
         <a
            :class="{active: sortOption === 'role'}"
            class="dropdown-item"
            @click="sortOption = 'role'"
            >Job role</a
         >
         <a
            :class="{active: sortOption === 'domain'}"
            class="dropdown-item"
            @click="sortOption = 'domain'"
            >Job domain</a
         >
         <a
            :class="{active: sortOption === 'level'}"
            class="dropdown-item"
            @click="sortOption = 'level'"
            >Job level</a
         >
         <a
            :class="{active: sortOption === 'education'}"
            class="dropdown-item"
            @click="sortOption = 'education'"
            >Educational requirements</a
         >
      </div>
   </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
import {sortBy} from 'lodash';
import $ from 'jquery';

export default {
   name: 'SortMenu',
   props: ['disabled'],
   data: function() {
      return {
         sortOption: 'role',
      };
   },
   mounted: function() {
      // https://stackoverflow.com/questions/31829312
      $(this.$refs.dropdown).on('show.bs.dropdown', function() {
         $('body').append(
            $('.sort-menu')
               .css({
                  position: 'absolute',
                  left: $('.dropdown').offset().left,
                  top: $('.dropdown').offset().top,
               })
               .detach()
         );
         // hide the tooltip
         console.log(this);
         $('#dropdownMenuButton').popover('hide');
      });
   },
   methods: {
      sortCareers: function(careers) {
         let sortOrder = [];
         switch (this.sortOption) {
            case 'role':
               sortOrder = ['jobRole', 'jobDomain'];
               break;
            case 'domain':
               sortOrder = ['jobDomain', 'jobRole'];
               break;
            case 'level':
               sortOrder = ['jobLevel', 'jobRole', 'jobDomain'];
               break;
            case 'education':
               sortOrder = ['sortingKey', 'jobRole', 'jobDomain'];
               break;
         }
         console.log(sortOrder);
         return sortBy(careers, sortOrder);
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/SortMenu.vue